import { fromJS } from 'immutable';
import * as actions from '../actions/prodigyai';

const initialState = fromJS({
  selectionFields: {
    loading: false,
    error: null,
    data: null,
  },
  queryResult: {
    loading: false,
    error: null,
    data: null,
  },
  years: {
    loading: false,
    error: null,
    data: null,
  },
  rollCorrections: {
    loading: false,
    error: null,
    data: null,
  },
  savedQueries: {
    loading: false,
    error: null,
    data: null,
  },
});

export default function prodigyaiReducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.FETCH_SELECTION_FIELDS.REQUEST:
      return state.setIn(['selectionFields', 'loading'], true);
    case actions.FETCH_SELECTION_FIELDS.SUCCESS:
      return state
        .setIn(['selectionFields', 'loading'], false)
        .setIn(['selectionFields', 'data'], fromJS(action.payload))
        .setIn(['selectionFields', 'error'], null);
    case actions.FETCH_SELECTION_FIELDS.FAILURE:
      return state
        .setIn(['selectionFields', 'loading'], false)
        .setIn(['selectionFields', 'error'], action.payload);

    case actions.CREATE_QUERY.REQUEST:
      return state.setIn(['queryResult', 'loading'], true);
    case actions.CREATE_QUERY.SUCCESS:
      return state
        .setIn(['queryResult', 'loading'], false)
        .setIn(['queryResult', 'data'], fromJS(action.payload))
        .setIn(['queryResult', 'error'], null);
    case actions.CREATE_QUERY.FAILURE:
      return state
        .setIn(['queryResult', 'loading'], false)
        .setIn(['queryResult', 'error'], action.payload);

    case actions.FETCH_ALL_YEARS.REQUEST:
      return state.setIn(['years', 'loading'], true);
    case actions.FETCH_ALL_YEARS.SUCCESS:
      return state
        .setIn(['years', 'loading'], false)
        .setIn(['years', 'data'], fromJS(action.payload))
        .setIn(['years', 'error'], null);
    case actions.FETCH_ALL_YEARS.FAILURE:
      return state
        .setIn(['years', 'loading'], false)
        .setIn(['years', 'error'], action.payload);

    case actions.FETCH_ROLL_CORRECTIONS.REQUEST:
      return state.setIn(['rollCorrections', 'loading'], true);
    case actions.FETCH_ROLL_CORRECTIONS.SUCCESS:
      return state
        .setIn(['rollCorrections', 'loading'], false)
        .setIn(['rollCorrections', 'data'], fromJS(action.payload))
        .setIn(['rollCorrections', 'error'], null);
    case actions.FETCH_ROLL_CORRECTIONS.FAILURE:
      return state
        .setIn(['rollCorrections', 'loading'], false)
        .setIn(['rollCorrections', 'error'], action.payload);

    case actions.FETCH_SAVED_QUERIES.REQUEST:
      return state.setIn(['savedQueries', 'loading'], true);
    case actions.FETCH_SAVED_QUERIES.SUCCESS:
      return state
        .setIn(['savedQueries', 'loading'], false)
        .setIn(['savedQueries', 'data'], fromJS(action.payload))
        .setIn(['savedQueries', 'error'], null);
    case actions.FETCH_SAVED_QUERIES.FAILURE:
      return state
        .setIn(['savedQueries', 'loading'], false)
        .setIn(['savedQueries', 'error'], action.payload);

    case actions.SAVE_QUERY.SUCCESS:
      return state.updateIn(['savedQueries', 'data'], (queries) =>
        queries
          ? queries.push(fromJS(action.payload))
          : fromJS([action.payload]),
      );

    case actions.DELETE_QUERY.SUCCESS:
      return state.updateIn(['savedQueries', 'data'], (queries) =>
        queries.filter((q) => q.get('id') !== action.meta.queryId),
      );

    default:
      return state;
  }
}
